import { Layers, Cpu, ShieldCheck, HardHat, Repeat, Headphones } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const REASONS = [
  { icon: Layers, title: "End-to-End Solutions", desc: "From equipment supply to infrastructure deployment — one accountable partner across the full scope." },
  { icon: Cpu, title: "Telecom Expertise", desc: "Focused knowledge of telecom and networking infrastructure, not generalist supply." },
  { icon: ShieldCheck, title: "Quality Products", desc: "Reliable telecom, optical and networking equipment sourced for dependable field performance." },
  { icon: HardHat, title: "Infrastructure Capability", desc: "Strong capability in underground and aerial OFC works, backed by disciplined process." },
  { icon: Repeat, title: "Flexible Connectivity", desc: "Fiber lease, rental, co-location and connectivity solutions shaped around your requirement." },
  { icon: Headphones, title: "24/7 Support", desc: "Telecom infrastructure requires continuous availability. JAYTRIKA provides support throughout the year." },
];

export default function WhyChoose() {
  return (
    <section id="why-jaytrika" data-testid="why-choose-section" className="bg-slate-50 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHead
          eyebrow="Why Choose JAYTRIKA"
          title="Why Businesses Choose JAYTRIKA"
          sub="The qualities that matter when infrastructure has to work — every route, every link, every day."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`why-card-${i}`}
                className="group h-full rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-blue-400/50 hover:shadow-2xl hover:shadow-blue-500/10"
              >
                <span className="inline-flex rounded-xl bg-gradient-to-br from-electric to-cyan-500 p-3 text-white shadow-lg shadow-blue-500/25 transition-transform duration-300 group-hover:scale-110">
                  <r.icon size={20} />
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold tracking-tight text-navy">{r.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
